import {SettingValueType, SocketValueType} from "@cm/material-nodes"

export const colorForValueType = (valueType?: SettingValueType) => {
    if (!valueType) {
        return undefined
    }
    switch (valueType) {
        case "vector":
            return "#6e5eb2"
        case "color":
            return "#8d802f"
        case "int":
        case "float":
            return "#4987af"
        case "closure":
            return "#2d8a5d"
    }
    return "#b5b5b5"
}

export const colorForConnection = (fromValueType?: SocketValueType, toValueType?: SocketValueType) => {
    if (!!fromValueType && fromValueType === toValueType) {
        switch (fromValueType) {
            case "vector":
                return "#403768"
            case "color":
                return "#685e23"
            case "float":
                return "#325a75"
            case "closure":
                return "#216544"
        }
    }
    return "#b32c2c"
}
